import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { useContextSelector } from 'use-context-selector';
import { ShoppingListProductsContext } from '../ShoppingListProductsContext';

const ShoppingListDescriptionCell = (props: GridCellProps) => {
  const { value } = useGridCellDisplayValue(props);

  const handleViewProductDetails = useContextSelector(
    ShoppingListProductsContext,
    (state) => state.handleViewProductDetails
  );

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" title={value}>
      <button
        type="button"
        className="text-[#0E80B4] hover:underline focus:outline-2 focus:outline-black rounded text-left truncate w-[100%]"
        onClick={(e) => handleViewProductDetails(e, props.dataItem)}
      >
        {value}
      </button>
    </GridCellBase>
  );
};

export default ShoppingListDescriptionCell;
